import { render, staticRenderFns } from "./Aliplayer.vue?vue&type=template&id=add4290e&"
import script from "./Aliplayer.vue?vue&type=script&lang=js&"
export * from "./Aliplayer.vue?vue&type=script&lang=js&"
import style0 from "./Aliplayer.vue?vue&type=style&index=0&id=add4290e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports